import { Directive, EventEmitter, HostListener, input, Output } from '@angular/core';

@Directive({
  selector: '[andorSubmit]',
  standalone: true,
})
export class SubmitDirective {
  @Output() andorSubmit = new EventEmitter<void>();
  andorSubmitDisabled = input(false);

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: Event) {
    if (this.andorSubmitDisabled()) return;
    event.preventDefault();
    this.andorSubmit.emit();
  }
}
